import TcButton from 'components/UI/button/TcButton';
import TcFormItem from 'components/UI/form/TcFormItem';
import TcFormWrapper from 'components/UI/FormWrapper/TcFormWrapper';
import TcPopconfirm from 'components/UI/Popconfirm/TcPopconfirm';
import TcShowInfo from 'components/UI/ShowInfo/TcShowInfo';
import TcDetailIcon from 'components/UI/TableIcons/TcDetailIcon';
import { separator } from 'global/default';
import { orderReservedByLocker } from './lockerModel';

interface PopupMarkerContentProps {
  address: string;
  lat: number;
  lng: number;
  // lockers: locker[];
  id: number;
}

const reservedLockerOrderContent = 'لاکر برای بسته شما رزرو شد .';
const lockerWasFulled = 'در مقصد انتخابی شما لاکر جابار وجود ندارد.';
const errorMessage = 'کد خطا: 3 _ یافت نشد';

const reservedLockerInfo = (orderReservationData: orderReservedByLocker) => (
  <>
    <TcFormWrapper>
      <TcShowInfo right='شماره سفارش' left={orderReservationData.orderNumber} />
      <TcShowInfo right='شماره ثبت' left={orderReservationData.registerDate + ' - ' + orderReservationData.registerTime} />
      <TcShowInfo right='تاریخ شروع' left={orderReservationData.startDate + ' - ' + orderReservationData.startTime} />
      <TcShowInfo right='تاریخ پایان' left={orderReservationData.endDate + ' - ' + orderReservationData.endTime} />
      <TcShowInfo right='هزینه استفاده از لاکر' left={separator(orderReservationData.finalAmount)} />
    </TcFormWrapper>
    <div className='flex items-center gap-2 whitespace-nowrap'>
      <p>هزینه استفاده از لاکر</p>
      <hr className='w-full border border-dashed border-t-border-color-base' />
      <p>{separator(orderReservationData.lockerAmount)} ریال</p>
    </div>
    <div className='flex items-center gap-2 whitespace-nowrap'>
      <p>مالیات</p>
      <hr className='w-full border border-dashed border-t-border-color-base' />
      <p>{separator(orderReservationData.taxAmount)} ریال</p>
    </div>
    <div className='flex items-center gap-2 whitespace-nowrap'>
      <p>هزینه نهایی</p>
      <hr className='w-full border border-dashed border-t-border-color-base' />
      <p>{separator(orderReservationData.finalAmount)} ریال</p>
    </div>
  </>
);

const PopupMarkerContent = (
  loading: boolean,
  inqueryKioskloading: boolean,
  callInquiryKioskForGettingEmptyLockers: (_kioskId: number) => Promise<void>,

  { address, lat, lng, id }: PopupMarkerContentProps
) => {
  return (
    <div className='p-2 text-right'>
      <p className='flex flex-wrap justify-between font-medium direction-rtl'>
        <span className='text-sm text-t-secondary-text-color'>آدرس کیوسک:</span>
        {address}
      </p>
      <p className='flex flex-wrap justify-between font-medium direction-rtl'>
        <span className='text-sm text-t-secondary-text-color'>عرض:</span>
        {lat}
      </p>
      <p className='flex justify-between font-medium direction-rtl'>
        <span className='text-sm text-t-secondary-text-color'>طول:</span>
        {lng}
      </p>
      <TcFormItem button className='text-center'>
        <TcButton loading={loading || inqueryKioskloading} type='primary' onClick={() => callInquiryKioskForGettingEmptyLockers(id)}>
          رزرو کیوسک
        </TcButton>
      </TcFormItem>
    </div>
  );
};

const columns = (
  callInquiryKioskForGettingEmptyLockers: (_kioskId: number) => Promise<void>,
  setSelectedLocation: React.Dispatch<React.SetStateAction<{ lat: number; lng: number } | undefined>>
) => [
  {
    title: 'آدرس',
    key: 'address',
    dataIndex: 'address',
  },
  {
    title: 'توضیحات',
    key: 'description',
    dataIndex: 'description',
  },
  // {
  //   title: 'عرض جغرافیایی',
  //   key: 'lat',
  //   dataIndex: 'lat',
  //   render: (_text: any, record: Record<string, any>) => {
  //     return record.lat;
  //   },
  // },
  // {
  //   title: 'طول جغرافیایی',
  //   key: 'lon',
  //   dataIndex: 'lon',
  //   render: (_text: any, record: Record<string, any>) => {
  //     return record.lon;
  //   },
  // },
  {
    title: 'رزرو کیوسک',
    key: 'select',
    dataIndex: 'select',
    render: (_text: string, record: Record<string, any>) => (
      <TcPopconfirm
        title='از انتخاب کیوسک مطمئنید؟'
        // onConfirm={() => setLockersList(record.lockers)}
        onConfirm={() => callInquiryKioskForGettingEmptyLockers(record.id)}>
        <span className='cursor-pointer text-t-secondary-color hover:underline'>رزرو</span>
      </TcPopconfirm>
    ),
  },
  {
    title: 'مشاهده موقعیت روی نقشه',
    key: 'select',
    dataIndex: 'select',
    render: (_text: string, record: Record<string, any>) => {
      if (record.lat && record.lon) {
        return <TcDetailIcon onClick={() => setSelectedLocation({ lat: record.lat, lng: record.lon })} />;
      } else return '';
    },
  },
];
const OmParcelOrderModel = { reservedLockerInfo, PopupMarkerContent, columns, reservedLockerOrderContent, lockerWasFulled, errorMessage };
export default OmParcelOrderModel;
